"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddVoucherFormWrapper = void 0;
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _zod2 = require("zod");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _AddVoucherForm = require("./AddVoucherForm");
var _jsxRuntime = require("react/jsx-runtime");
// TODO: Reduce number of components
const AddVoucherFormWrapper = ()=>{
    const { isSimplifiedCheckout } = (0, _contexts.useCheckoutBasket)();
    const { shoppingBag } = (0, _contexts.useBasketContext)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    // TODO: Refactor to not be depend on formatMessage
    const voucherValidationSchema = _zod2.z.object({
        voucherCode: _zod2.z.string().min(1, formatMessage('voucherCodeIsRequired')).max(50, formatMessage('voucherCodeIsTooLong'))
    });
    const form = (0, _reactHookForm.useForm)({
        mode: 'onChange',
        defaultValues: {
            voucherCode: ''
        },
        // There is some random type issue with current zod and @hookform/resolvers versions
        resolver: (0, _zod.zodResolver)(voucherValidationSchema)
    });
    if (isSimplifiedCheckout !== null && isSimplifiedCheckout !== void 0 ? isSimplifiedCheckout : !shoppingBag) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
        ...form,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddVoucherForm.AddVoucherForm, {})
    });
};
exports.AddVoucherFormWrapper = AddVoucherFormWrapper;
